import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 border-t border-dark-border py-12 sm:py-16" data-id="element-72">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 sm:gap-10 mb-10 sm:mb-12" data-id="element-74">
          <div className="max-w-md text-center md:text-left" data-id="element-75">
            <div className="font-editorial text-gold/70 text-sm mb-1" data-id="element-76">
              Atlas Clínico
            </div>
            <div className="text-xl sm:text-2xl font-heading font-extrabold text-white mb-3 sm:mb-4 tracking-tight" data-id="element-77">
              MEGA PACK KINESIOLOGÍA™
            </div>
            <p className="text-gray-400 text-sm mb-3 sm:mb-4 leading-relaxed" data-id="element-78">
              El sistema de evaluación clínica para estudiantes de kinesiología
              y kinesiólogos junior en Argentina.
            </p>
            <p className="text-gray-500 text-xs sm:text-sm italic leading-relaxed" data-id="element-79">
              Porque evaluar bien no debería ser una habilidad que se aprende
              sola, de a poco, después de cometer errores que se podían evitar.
            </p>
          </div>

          <div className="text-center md:text-right space-y-2" data-id="element-80">
            <a href="mailto:soporte@atlasclinico.com" className="block text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-81">
              📧 soporte@atlasclinico.com
            </a>
            <a href="#" className="block text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-82">
              📲 @atlasclinico
            </a>
            <a href="#" className="block text-sm text-gray-400 hover:text-gold transition-colors" data-id="element-83">
              🌐 www.atlasclinico.com
            </a>
          </div>
        </div>

        <div className="border-t border-dark-border pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4" data-id="element-84">
          <p className="text-gray-600 text-xs text-center md:text-left leading-relaxed" data-id="element-85">
            © Atlas Clínico™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
          <p className="text-gold font-editorial italic text-sm" data-id="element-86">
            "Evaluar mejor empieza hoy."
          </p>
        </div>
      </div>
    </footer>;
}